import React from 'react'
import { FormattedHTMLMessage, Button, newIcons, AppSvg } from '@web/walter-ui-kit'

import s from './s.module.css'
import { lang } from './lang'
import { useCards } from '~api'

function Error() {
    const { mutate, isValidating } = useCards()

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                <div className={s.contentText}>
                    <FormattedHTMLMessage className={s.title} {...lang.title} />
                    <FormattedHTMLMessage className={s.description} {...lang.description} />
                </div>
                <div className={s.button}>
                    <Button
                        mode="primary"
                        size="m"
                        dataPointer="reload"
                        onClick={() => mutate()}
                        isLoading={isValidating}
                        prefix={<AppSvg svgName={newIcons.ic24Refresh} size={24} path="new-icons" />}
                    >
                        <FormattedHTMLMessage {...lang.button} />
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Error
